var Bavaria = "Bavaria";
var Berlin = "Berlin";
var Brandenburg = "Brandenburg";
var Bremen = "Bremen";
var Hamburg = "Hamburg";
var Hesse = "Hesse";
var Saarland = "Saarland";
var Saxony = "Saxony";
var Thuringia = "Thuringia";
var DEStates = {
	"Baden-Wuerttemberg": "Baden-Wuerttemberg",
	Bavaria: Bavaria,
	Berlin: Berlin,
	Brandenburg: Brandenburg,
	Bremen: Bremen,
	Hamburg: Hamburg,
	Hesse: Hesse,
	"Mecklenburg-Vorpommern": "Mecklenburg-Vorpommern",
	"Lower Saxony": "Lower Saxony",
	"North Rhine-Westphalia": "North Rhine-Westphalia",
	"Rhineland-Palatinate": "Rhineland-Palatinate",
	Saarland: Saarland,
	Saxony: Saxony,
	"Saxony-Anhalt": "Saxony-Anhalt",
	"Schleswig-Holstein": "Schleswig-Holstein",
	Thuringia: Thuringia
};

export { Bavaria, Berlin, Brandenburg, Bremen, Hamburg, Hesse, Saarland, Saxony, Thuringia, DEStates as default };
